import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DropDownContent} from '../Models/dropDownContent';
import {SecurableObjectAcessControlEntry} from '../Models/SecurableObjectAcessControlEntry';

@Injectable({
  providedIn: 'root'
})
export class AccessControlService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getSecurableObjectPermissions(securableObjectType: number) {
    return this.http.post<DropDownContent[]>('api/accessControl/GetSecurableObjectPermissions',
      { securableObjectType: securableObjectType } );
  }

  getAccessControlEntries(params: any) {
    return this.http.post<SecurableObjectAcessControlEntry[]>('api/accessControl/LoadAccessControlEntries', params);
  }

  deleteAccessControlEntries(params: any[]) {
    return this.http.post<void>('api/accessControl/DeleteAccessControlEntries', params);
  }

  addAccessControlEntries(params: any[]) {
    return this.http.post<void>('api/accessControl/AddAccessControlEntries', params);
  }

  getAllEffectiveEntriesBySecurableObjectTypeAndUser(securableObjectType) {
    return this.http.get<any[]>(`api/accessControl/getAllEffectiveEntriesBySecurableObjectTypeAndUser/${securableObjectType}`);
  }

  getUsersWithEffectivePermissionOnState(stateIds: number[], permissionName: string) {
    return this.http.post<any[]>('api/accessControl/getUsersWithEffectivePermissionOnState',
      { stateIds: stateIds, permissionName: permissionName });
  }

  getUsersWithEffectivePermissionOnAnyState(stateIds: number[], permissionName: string) {
    return this.http.post<any[]>('api/accessControl/getUsersWithEffectivePermissionOnAnyState',
      { stateIds: stateIds, permissionName: permissionName});
  }

  getUsersPermissionOnStateAndCustomQueues(stateIds: number[], permissionName: string, customQueueIds: number[]) {
    const params = {
      stateIds: stateIds,
      permissionName: permissionName,
      customQueueIds: customQueueIds
    };
    return this.http.post<any[]>('api/accessControl/getUsersPermissionOnStateAndCustomQueues', params);
  }
}
